import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import moment from 'moment'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import GiftContext from '@/product/context/giftCard/giftContext'

const GiftManage = (props) => {
    const giftContext = useContext(GiftContext)

    const { getSingleGiftCard, search_single_giftcard, giftCardAction } =
        giftContext
    function generateCouponCode() {
        const length = 16
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        let coupon = ''

        let hasNumber = false

        let hasChar = false

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length)
            const randomChar = charset[randomIndex]

            if ('0123456789'.includes(randomChar)) {
                hasNumber = true
            }

            if ('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.includes(randomChar)) {
                hasChar = true
            }

            coupon += randomChar
        }

        if (!hasNumber || !hasChar) {
            return generateCouponCode()
        }

        return coupon
    }

    const [product, setProduct] = useState(null)

    const data = props.data
    const toggleFullScreenPopup = props.function
    const noExpiry = props.noExpiry

    const validationArray = Yup.object({
        code: Yup.string().min(16, 'Code is not valid').required('Required!'),
        discount: Yup.string().required('Required!'),
        start_date: Yup.date('Please enter valid date!')
            .nullable()
            .required('Required!'),
        end_date: Yup.date('Please enter valid date!')
            .min(Yup.ref('start_date'), 'Should be greater than start date')
            .nullable()
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            code: '',
            discount: '',
            discount_type: 'amount',
            start_date: noExpiry ? dateTimeFormatFunction(moment()) : '',
            end_date: noExpiry
                ? dateTimeFormatFunction(moment('2099-12-31T23:59:59'))
                : '',
            description: '',
            defaultAddition: true,
            enabled: 1,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.start_date) {
                values.start_date = moment(
                    values.start_date,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
            if (values.end_date) {
                values.end_date = moment(
                    values.end_date,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }

            giftCardAction(values)
        },
    })

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getSingleGiftCard(formik.values)
        } else {
            resetFrom()
        }
    }, [data])

    useEffect(() => {
        if (search_single_giftcard.record && data.status === 'edit') {
            const template = search_single_giftcard.record.length
                ? search_single_giftcard.record[0]
                : {}

            setProduct(template)
            formik.values.id = template.id
            formik.values.code = template.code
            formik.values.discount = template.discount
            if (noExpiry) {
                formik.values.start_date = dateTimeFormatFunction(moment())
                formik.values.end_date = dateTimeFormatFunction(
                    moment('2099-12-31T23:59:59')
                )
            } else {
                formik.values.start_date = dateTimeFormatFunction(
                    template.start_date
                )
                formik.values.end_date = dateTimeFormatFunction(
                    template.end_date
                )
            }
            formik.values.discount_type = template.discount_type
            formik.values.description = template.description
        } else {
            resetFrom()
        }
    }, [search_single_giftcard])

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.code = generateCouponCode()
        formik.values.discount = ''
        formik.values.start_date = noExpiry
            ? dateTimeFormatFunction(moment())
            : ''
        formik.values.end_date = noExpiry
            ? dateTimeFormatFunction(moment('2099-12-31T23:59:59'))
            : ''
        formik.values.description = ''
        setProduct(null)
        formik.handleReset()
    }

    const emailTemplate = []

    emailTemplate.push({
        label: 'Gift Code',
        placeholder: 'Enter Gift Code',
        class: 'col-12',
        type: 'text',
        shrink: true,
        name: 'code',
        formik: formik,
    })
    emailTemplate.push({
        label: 'Discount Type',
        placeholder: 'Select Discount Type',
        class: 'col-6',
        type: 'select',
        options: [
            { value: 'amount', show: 'Amount' },
            // { value: 'percentage', show: 'Percentage' },
        ],
        name: 'discount_type',
        formik: formik,
    })
    emailTemplate.push({
        label: `Discount ${
            formik.values.discount_type === 'amount' ? 'Amount' : 'Percentage'
        }`,
        placeholder: `Enter Discount ${
            formik.values.discount_type === 'amount' ? 'Amount' : 'Percentage'
        }`,
        class: 'col-6',
        type: 'number',
        shrink: true,
        name: 'discount',
        formik: formik,
    })

    if (!noExpiry) {
        emailTemplate.push({
            label: 'Gift Card Start',
            placeholder: 'Enter Gift Card Start date',
            type: 'datetime',
            disablePast: true,
            class: 'col-md-3 col-sm-6 col-12',
            name: 'start_date',
        })
        emailTemplate.push({
            label: 'Gift Card End',
            placeholder: 'Enter Gift Card End date',
            type: 'datetime',
            disablePast: true,
            class: 'col-md-3 col-sm-6 col-12',
            name: 'end_date',
        })
    }

    emailTemplate.push({
        label: 'Gift Card Notes',
        placeholder: 'Enter Gift Card Notes',
        class: 'col-12',
        type: 'textarea',
        shrink: true,
        name: 'description',
        formik: formik,
    })

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'ADD Gift Card' : `EDIT Gift Card`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">
                            {Object.values(mapData(emailTemplate))}
                        </div>

                        <div className="actionButton d-flex justify-content-center align-items-center">
                            <SecondaryButton
                                id="configManage_cancel"
                                label="Cancel"
                                onClick={() => toggleFullScreenPopup(false)}
                            />
                            <PrimaryButton
                                id="configManage_submit"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default GiftManage
